import { DateTimeService } from '@mews/framework';

export const getEndUtcForHourlyUnit = (timeUtc: string, timezone: string) => {
    const dateTime = DateTimeService.fromUtcString(timeUtc, timezone);
    // For hourly time units, we need 24 hours into future minus one hour in order to get 24 dateRange
    return DateTimeService.toUtc(
        DateTimeService.addHours(DateTimeService.addDays(DateTimeService.startOfDay(dateTime), 1), -1)
    ).value;
};
